export default "__VITE_ASSET__mYCjI928__"